import FieldsetRegisterEntry from './FieldsetRegisterEntry.yaml?component';
import UcRegister from './UcRegister.yaml?component';
import UcRegisterEntryHeader from './UcRegisterEntryHeader.yaml?component';
import UcRegisterEntryInvoiceSelector from './UcRegisterEntryInvoiceSelector.yaml?component';
import UcRegisterEntryPartnerSelector from './UcRegisterEntryPartnerSelector.yaml?component';
import UcRegisterVersions from './UcRegisterVersions.yaml?component';

export {
  FieldsetRegisterEntry,
  UcRegister,
  UcRegisterEntryHeader,
  UcRegisterEntryInvoiceSelector,
  UcRegisterEntryPartnerSelector,
  UcRegisterVersions
};
